import App from '@modules/husleie-framework/src/static-classes/App.class.js';
import type {
  SessionAPIInterface,
  SessionGet,
  SessionGetResponse,
  SessionCreate,
  SessionCreateResponse,
  SessionClone,
  SessionCloneResponse,
  SessionUpdate,
  SessionUpdateResponse,
  SessionDelete,
  SessionPreview,
  SessionPreviewResponse,
  SessionSigningMethodsGet,
  SessionSigningMethodsGetResponse,
  SessionSigningPrepare,
  SessionSigningPrepareResponse,
} from '@modules/store/session/types/SessionAPI.interface';
import APIMocked from './index.mock-api';
import APIReal from './index.real-api';

export default class API implements SessionAPIInterface {
  private readonly api: any;

  constructor() {
    this.api = App.isMockedAPI() ? new APIMocked() : new APIReal();
  }

  getSession(get: SessionGet): Promise<SessionGetResponse> {
    return this.api.getSession(get);
  }

  createSession(create: SessionCreate): Promise<SessionCreateResponse> {
    return this.api.createSession(create);
  }

  cloneSession(clone: SessionClone): Promise<SessionCloneResponse> {
    return this.api.cloneSession(clone);
  }

  updateSession(update: SessionUpdate): Promise<SessionUpdateResponse> {
    return this.api.updateSession(update);
  }

  deleteSession(del: SessionDelete): Promise<void> {
    return this.api.deleteSession(del);
  }

  fetchSessionPreview(download: SessionPreview): Promise<SessionPreviewResponse> {
    return this.api.fetchSessionPreview(download);
  }

  getSessionSigningMethods(get: SessionSigningMethodsGet): Promise<SessionSigningMethodsGetResponse> {
    return this.api.getSessionSigningMethods(get);
  }

  prepareSessionSigning(prepare: SessionSigningPrepare): Promise<SessionSigningPrepareResponse> {
    return this.api.prepareSessionSigning(prepare);
  }
}
